/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkPackageStatusRequest } from '../../models/create-work-package-status-request';
import { WorkPackageStatusDto } from '../../models/work-package-status-dto';

export interface CreateWorkPackageStatus$Params {
      body: CreateWorkPackageStatusRequest
}

export function createWorkPackageStatus(http: HttpClient, rootUrl: string, params: CreateWorkPackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageStatusDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackageStatus.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageStatusDto>;
    })
  );
}

createWorkPackageStatus.PATH = '/v0/workPackageStatuses/{id}';
